import { render } from "./DrinkImage.vue?vue&type=template&id=67501a50"
import script from "./DrinkImage.vue?vue&type=script&lang=js"
export * from "./DrinkImage.vue?vue&type=script&lang=js"

import "./DrinkImage.vue?vue&type=style&index=0&id=67501a50&lang=css"
script.render = render

export default script